import { render, staticRenderFns } from "./VacancyDetail.vue?vue&type=template&id=77fb605b"
import script from "./VacancyDetail.vue?vue&type=script&lang=js"
export * from "./VacancyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports